<template>
  <div>
    <PageContent :dataList="options" title="防伪信息" ref="pageContentRef">
      <template v-slot="itemData">
        <div class="securityInfo">
          <div class="item" v-if="itemData.itemData.op.op.tag_type == 1">
            芯片状态：<span>{{
              itemData.itemData.op.op.chinStatus ? "已撕毁" : "完好"
            }}</span>
          </div>
          <div class="item">
            当前已验证次数：<span>{{
              itemData.itemData.op.op.polled_num
            }}</span>
          </div>
          <div class="item">
            最后验证时间：<span>{{
              itemData.itemData.op.op.created_date | formant
            }}</span>
          </div>
          <div class="item">
            防伪码：<span>{{
              itemData.itemData.op.op.mark_security_code
            }}</span>
          </div>
        </div>
      </template>
    </PageContent>
    <!-- <div class="securityInfo">
      <div class="title">{{ options.trace_name }}</div>
   
      <div class="item">
        当前查询次数：<span>{{ options.polled_num }}</span>
      </div>
      <div class="item">
        验证状态：<span>{{ options.check_status ? "已验证" : "未验证" }}</span>
      </div>
      <div class="item">
        最后验证时间：<span>{{ options.created_date||'未验证' }}</span>
      </div>
    </div> -->

    <!-- <PageContent :dataList="listData" title="防伪信息">

    </PageContent> -->
  </div>
</template>

<script>
import PageContent from "../components/templateContent";
export default {
  components: {
    PageContent,
  },
  data() {
    return {
      options: {},
    };
  },
  created() {
    try {
      this.$setApptitle("链宇宙防伪溯源");
    } catch {
      console.log("not webview");
    }
    this.defaultId = this.$route.query.defaultId;
    this.listData = JSON.parse(localStorage.getItem("idInObj"))[2];
    // 获取防伪信息
    this.options = this.listData;
    console.log(this.listData);
    // if (this.listData && this.listData.msgItems) {
    //   this.isShowPage();
    // }
    // // 获取溯源码id
    this.suyuanId = localStorage.getItem("id");
    // console.log(this.options);
    // console.log(this.options);
  },
  methods: {
    goToSertificate() {
      this.$router.push("/look");
    },
    isShowPage() {
      if (this.listData.msgItems) {
        setTimeout(() => {
          this.$refs.pageContentRef.flagBoxFather();
          setTimeout(() => {
            this.$refs.pageContentRef.titleChildSwitch(
              0,
              this.listData.msgItems[0].txid
            );
          });
        }, 500);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.securityInfo {
  padding: 0 40px;
  .certificate {
    position: relative;
    margin: 48px 96px;
    width: 366px;
    height: 580px;
    background: #fff;

    .chap {
      position: absolute;
      top: -264px;
      left: -160px;
      transform: scale(0.5, 0.5);
    }
  }
  .item {
    &:first-child {
      padding-top: 0;
    }
    // margin-bottom: 56px;
    font-size: 28px;
    padding: 30px 0;
    border-bottom: 1px solid #e2e2e2;
    font-family: PingFang SC;
    line-height: 38px;
    color: #222222;
    span {
      font-size: 28px;
      font-family: PingFang SC;
      color: #808080;
    }
  }
}
</style>
